const getBrowserLanguage = (): string => {
  return (window.navigator as any).userLanguage || window.navigator.language;
};

export default getBrowserLanguage;
